import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
    selector: 'app-settings-actions-modal',
    templateUrl: './settings-actions-modal.component.html',
    styleUrls: ['./settings-actions-modal.component.css']
})
export class SettingsActionsModalComponent implements OnInit {

    modalData: any;

    constructor(
        private bsModalRef: BsModalRef,
        public bsModalService: BsModalService
    ) {
        if(this.bsModalService.config.initialState) {
            this.modalData = this.bsModalService.config.initialState;
        }
    }

    ngOnInit() {
    }

    closeModal() {
        this.bsModalRef.hide();
    }
}
